import { ApiError, apiFetch } from './client';
/**
 * What the DICOM tag editor shows: the study's editable tags as its files hold them, next to
 * the worklist's copy. `focusSopInstanceUid` names the image the viewer is showing, which is
 * always listed with its image-level tags.
 */
export async function getStudyDicomTags(studyId, focusSopInstanceUid) {
    const qs = focusSopInstanceUid
        ? `?focusSopInstanceUid=${encodeURIComponent(focusSopInstanceUid)}`
        : '';
    return apiFetch(`/study/${encodeURIComponent(studyId)}/dicom-tags${qs}`);
}
/** Queues the rewrite of the study's files; the worklist copies change at once. */
export async function submitDicomEdits(studyId, body) {
    return apiFetch(`/study/${encodeURIComponent(studyId)}/dicom-edits`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
}
/** The study's newest DICOM tag edit, or null when it has none (404). */
export async function getLatestDicomEditJob(studyId) {
    try {
        return await apiFetch(`/study/${encodeURIComponent(studyId)}/dicom-edit-jobs/latest`);
    }
    catch (error) {
        if (error instanceof ApiError && error.status === 404)
            return null;
        throw error;
    }
}
